export interface IAddress {
  address1: string;
  address2: string | null;
  city: string;
  stateAbbreviation: string;
  postalCode: string;
}

export class Address implements IAddress {
  address1: string;
  address2: string | null;
  city: string;
  stateAbbreviation: string;
  postalCode: string;

  constructor(
    address1?: string,
    address2?: string | null,
    city?: string,
    stateAbbreviation?: string,
    postalCode?: string
  ) {
    this.address1 = address1 || '';
    this.address2 = address2 || null;
    this.city = city || '';
    this.stateAbbreviation = stateAbbreviation || '';
    this.postalCode = postalCode || '';
  }
}
